export default "__VITE_PUBLIC_ASSET__968b19b4__"